import LoadingScreen from '@/ui-components/components/LoadingScreen'
import { useLocation } from 'react-router'

const Loading = ({
  loading,
  children,
}: {
  loading?: boolean
  children: React.ReactNode
}) => {
  const location = useLocation()
  return (
    <>
      <div
        className={`fixed inset-0 transition-opacity pointer-events-none ${loading ? 'opacity-100 duration-200' : 'opacity-0 duration-500'}`}
        style={{ zIndex: 15 }}
      >
        <LoadingScreen key={location.key} />
      </div>
      {children}
    </>
  )
}

export default Loading
